import './style.scss';
import Swiper from 'swiper';
import 'swiper/swiper.scss';

export function branches_careers_resources_block() {
    const block = document.querySelector('.branches_careers_resources_block');
    if (!block) return;

    const init = () => {
        // Swipers (scoped per section)
        const config = {
            slidesPerView: 1.27,
            spaceBetween: 0,
            breakpoints: {768: {slidesPerView: 2}, 992: {slidesPerView: 2}, 1280: {slidesPerView: 3}},
            observer: true,
            observeParents: true,
        };

        const sections = [
            {section: '.branches', controller: '.branches-controller', swiper: '.branches-swiper'},
            {section: '.careers', controller: '.careers-controller', swiper: '.careers-swiper'},
            {section: '.resources', controller: '.resources-controller', swiper: '.resources-swiper'},
        ];

        sections.forEach(({section, controller, swiper}) => {
            const sectionEl = block.querySelector(section);
            if (!sectionEl) return;

            const swiperEl = sectionEl.querySelector(swiper);
            const controllerEl = sectionEl.querySelector(controller);
            if (!swiperEl || !controllerEl) return;

            const s = new Swiper(swiperEl, config);

            const nextBtn = controllerEl.querySelector('.swiper-button-next');
            const prevBtn = controllerEl.querySelector('.swiper-button-prev');

            nextBtn?.addEventListener('click', (e) => {
                e.preventDefault();
                s.slideNext();
            });
            prevBtn?.addEventListener('click', (e) => {
                e.preventDefault();
                s.slidePrev();
            });

            const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
            if (slideCount <= 3) {
                controllerEl.style.display = 'none';
            } else if (!slideCount) {
                console.warn(`No .swiper-slide inside ${swiper} for ${section}.`);
            }
        });

        // Tabs: build map (tabs -> sections -> controllers)
        const tabs = Array.from(block.querySelectorAll('.desktop-tabs .tab[href^="#"]'));
        const tabMap = tabs
            .map((a) => {
                const id = a.getAttribute('href').slice(1);
                const el = document.getElementById(id);
                if (!el) return null;
                const controllerEl = el.querySelector('.controller-bar');
                return {id, tab: a, el, controllerEl};
            })
            .filter(Boolean);

// Tabs container for desktop trigger
        const tabsEl = block.querySelector('.desktop-tabs');

// Desktop vs Mobile helpers
        const mq = window.matchMedia('(min-width: 992px)');
        const isDesktop = () => mq.matches;

// Trigger lines
        const getTriggerYTop = () => {
            if (isDesktop()) {
                if (!tabsEl) return 0;
                return parseFloat(window.getComputedStyle(tabsEl).top) || 0;
            }
            // mobile: viewport top
            return tabsEl ? tabsEl.offsetHeight : 0;
        };
        const getTriggerYBottom = () => {
            if (isDesktop()) {
                const r = tabsEl?.getBoundingClientRect();
                return r ? r.bottom : 0;
            }
            // mobile: also use viewport top to drive activation
            return 80;
        };

// Activate a tab and its matching controller
        const setActiveTab = (id) => {
            tabMap.forEach(({id: secId, tab, controllerEl}) => {
                const isActive = secId === id;
                tab.classList.toggle('active', isActive);
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                tab.setAttribute('tabindex', isActive ? '0' : '-1');
                controllerEl?.classList.toggle('active-controller', isActive);
            });
        };

// Scrollspy: desktop -> tabs bottom, mobile -> viewport top
        const updateActiveFromScroll = () => {
            const triggerY = getTriggerYBottom();
            let current = null;

            for (const item of tabMap) {
                const rect = item.el.getBoundingClientRect();
                const crosses = rect.top <= triggerY && rect.bottom > triggerY;
                if (crosses) {
                    current = item;
                    break;
                }
            }

            if (!current) {
                current = tabMap
                    .map((t) => {
                        const rect = t.el.getBoundingClientRect();
                        return {t, dist: Math.abs(rect.top - triggerY)};
                    })
                    .sort((a, b) => a.dist - b.dist)[0]?.t;
            }

            if (current) setActiveTab(current.id);
        };

// Click: desktop -> align with tabs' top, mobile -> align with viewport top
        let suppressUntil = 0;
        tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                const id = tab.getAttribute('href').slice(1);
                const target = document.getElementById(id);
                if (!target) return;

                const triggerYTop = getTriggerYTop();
                const rect = target.getBoundingClientRect();
                const desiredTop = window.scrollY + rect.top - triggerYTop + 1;

                suppressUntil = Date.now() + 700;
                setActiveTab(id);
                window.scrollTo({top: desiredTop, behavior: 'smooth'});
            });
        });

// rAF-throttled scroll/resize
        let ticking = false;
        const onScrollOrResize = () => {
            if (Date.now() < suppressUntil) return;
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                ticking = false;
                updateActiveFromScroll();
            });
        };

        window.addEventListener('scroll', onScrollOrResize, {passive: true});
        window.addEventListener('resize', onScrollOrResize);
// also listen to MQ changes (orientation/width)
        mq.addEventListener?.('change', updateActiveFromScroll);

// Initial state
        requestAnimationFrame(() => {
            const hash = window.location.hash?.slice(1);
            const preferred = hash && tabMap.find((t) => t.id === hash);
            if (preferred) setActiveTab(preferred.id);
            else updateActiveFromScroll();
        });

    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}
